/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {searchChangeProposals} from '../api'

export const useMutationSearchChangeProposals = createReactQueryMutationHook('searchChangeProposals', searchChangeProposals)
